import React from "react";
import axios from "axios";

export const uploadApplicationDocumentsApi = async (id,token,file,name,query) => {
  const form = new FormData();
  form.append("files", file);
  form.append("document_name", name);

    try {
      const options = {
        method: "PUT",
        url : `https://visapro-api.tcore.online/api/v1/applications/${id}/upload?document_id=${query}`,
        headers: {
          'Authorization': `Basic ${token}` 
        },
        data: form,
      };
      const response = await axios.request(options)
      const fileUpload = {
        data: response.data.data,
      };
      return fileUpload;
    } catch (error) {
      const fileUpload = {
        error: error,
      };
      return fileUpload;
  }
};

